import React ,{ useEffect, useState } from 'react'
import Footer from './Footer'
import Header from './Header'
import Main from './Main'

import firebase from "firebase";
import { CircularProgress } from '@material-ui/core';
import Sidebar from './Sidebar';

function Konferencija() {

    const [pageState, setPageState] = useState(null)


    const db = firebase.database();

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
      setIsOpen(!isOpen);
    }
    
  
    useEffect(() => {
      if(pageState === null)
      {
        firebase.database().ref('/EditPage').once('value').then((promise)=>{   setPageState(promise.val()) })
      }
      
    },[pageState])
    

    if(pageState===null){ return <div style={{position:"fixed",
    top: "50%",
    left: "50%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"}}>
      
      
      <CircularProgress size="100px"/></div>
      
    }
    
    return (
        <div>
            <span id="pocetna"></span>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Header toggle={toggle}/>
            <Main pageState={pageState}/>
            <Footer kontakt={pageState.kontakt}/>
        </div>
    )
}

export default Konferencija
